const initState = {
    countryList: [],
};

export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';

export const setCountryList = (data) => ({ type: SET_COUNTRY_LIST, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_COUNTRY_LIST:
            return { ...state, countryList: action.payload };
        default:
            return state;
    }
};
